import styles from './BetaTag.module.scss';

export const BetaTag = () => {
  return <span className={styles.tag}>BETA</span>;
};
